import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_HOLIDAY,
  DELETE_HOLIDAY,
  GET_HOLIDAY,
  GET_HOLIDAY_DETAILS,
  UPDATE_HOLIDAY,
} from "./actionTypes.js";

import {
  addHolidayFail,
  addHolidaySuccess,
  deleteHolidayFail,
  deleteHolidaySuccess, 
  getHolidayDetailsFail,
  getHolidayDetailsSuccess,
  getHolidayFail,
  getHolidaySuccess,
  updateHolidayFail,
  updateHolidaySuccess,
} from "./actions.js";

import {
  addNewHoliday,
  holidayDetailsApi,
  holidayListingApi,
  delHoliday,
  updateHoliday,
} from "./holidayApi.js";

function* fetchHoliday({ payload: length, sort, page,name, sort_by }) {
  try {
    const response = yield call(holidayListingApi, length, sort, page,name, sort_by)
    yield put(getHolidaySuccess(response))
  } catch (error) {
    yield put(getHolidayFail(error))
  }
}
function* fetchHolidayDetails({ payload: id }) {
  try {
    const response = yield call(holidayDetailsApi, id)
    yield put(getHolidayDetailsSuccess(response))
  } catch (error) {
    yield put(getHolidayDetailsFail(error))
  }
}

function* onAddNewHoliday({ payload: holiday }) {
  try {
    const response = yield call(addNewHoliday, holiday)
    yield put(addHolidaySuccess(response))
  } catch (error) {
    yield put(addHolidayFail(error))
  }
}

function* onUpdateHoliday({ payload: id, holiday }) {
  try {
    const response = yield call(updateHoliday, id, holiday)
    yield put(updateHolidaySuccess(response))
  } catch (error) {
    yield put(updateHolidayFail(error))
  }
}

function* onDelHoliday({ payload: id }) {
  try {
    const response = yield call(delHoliday, id)
    yield put(deleteHolidaySuccess(response))
  } catch (error) {
    yield put(deleteHolidayFail(error))
  }
}


function* HolidaySaga() {
  yield takeEvery(GET_HOLIDAY, fetchHoliday)
  yield takeEvery(GET_HOLIDAY_DETAILS, fetchHolidayDetails)
  yield takeEvery(ADD_NEW_HOLIDAY, onAddNewHoliday)
  yield takeEvery(UPDATE_HOLIDAY, onUpdateHoliday)
  yield takeEvery(DELETE_HOLIDAY, onDelHoliday)
}

export default HolidaySaga
